import { ReactNode } from 'react';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { Description } from '@radix-ui/react-dialog';

import { Dialog, DialogContent, DialogTitle } from '@app/shared/ui/organisms/Common';
import { cn } from '@app/shared/utils/common';
import type { ImageWithBackgroundVariant } from '@app/shared/ui/molecules/Common';
import { FeaturedImagePosition } from '@app/shared/types/modal';

export interface ModalProps {
  isOpen: boolean;
  onOpenChange?: (value: boolean) => void;
  featuredImg?: ReactNode;
  featuredImgPosition?: FeaturedImagePosition;
  featuredImgBackgroundVariant?: ImageWithBackgroundVariant;
  displayCloseButton?: boolean;
  contentClassName?: string;
  hiddenTitle?: string;
  children: ReactNode;
  overlayClassName?: string;
}

export function Modal({
  isOpen,
  onOpenChange,
  featuredImg,
  featuredImgPosition,
  featuredImgBackgroundVariant,
  displayCloseButton = true,
  contentClassName,
  hiddenTitle,
  children,
  overlayClassName,
}: ModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        featuredImg={featuredImg}
        featuredImgPosition={featuredImgPosition}
        featuredImgBackgroundVariant={featuredImgBackgroundVariant}
        displayCloseButton={displayCloseButton}
        overlayClassName={overlayClassName}
        className={cn('bg-black-overlay text-foreground', contentClassName)}
      >
        <Description className={cn('hidden')}>{hiddenTitle}</Description>
        {hiddenTitle && (
          <VisuallyHidden>
            <DialogTitle>{hiddenTitle}</DialogTitle>
          </VisuallyHidden>
        )}
        {children}
      </DialogContent>
    </Dialog>
  );
}
